import React from "react";
import s from "./index.module.scss";
import GlassOptions from "containers/ProductDetails/components/ProductDetails/Details/GlassOptions/";
import DimensionOptions from "containers/ProductDetails/components/ProductDetails/Details/DimensionOptions/";
import { Heading, Tabs, Button } from "@masonite/external-ui-react";
import Swatches from "components/forms/Swatches";
import { language } from "utility/env";

const Details = ({
    product,
    options,
    activeTab,
    changeTab,
    containerState,
    setContainerState
    // setWhereToBuyClick
}) => {
    const activeTabId = activeTab && activeTab.hash;
    const applicationSlug = activeTab && activeTab.name.toLowerCase();
    const dimensions = options.dimensions[applicationSlug];

    var hideButton = {
        visualizeDoor: {
            display: "none"
        }
    };

    var showButton = {
        visualizeDoor: {
            display: "block"
        }
    };

    // Temp styles for Visualize Door Button
    const visualizeDoorStyle = () => {
        if (
            window.innerWidth > 500 ||
            window.location.origin === "https://residential.masonite.com"
        ) {
            return hideButton;
        } else {
            return showButton;
        }
    };

    const textureHeading = "Texture";

    const getFinishLabel = label => {
        if (language === "fr") {
            if (label.name.toLowerCase() === "paintable") {
                return "Prêt pour la peinture";
            } else {
                return "Prêt pour les taches";
            }
        } else {
            if (label.name.toLowerCase() === "stainable") {
                return "Ready for stain";
            } else {
                return "Ready for paint";
            }
        }
    };

    const subtitle = product.title !== product.subtitle && (
        <Heading level="2">{product.subtitle}</Heading>
    );

    const tabs = options.application
        ? options.application
              .map(option => {
                  if (option.name === "Interal") option.name = "Internal";
                  if (option.name === "External") option.name = "External";
                  return option;
              })
              .map(option => ({
                  id: option.hash,
                  children: (
                      <Heading level="3" noMargin>
                          {option.name}
                      </Heading>
                  )
              }))
        : [];

    const Section = ({ children }) => (
        <section className={s.section}>{children}</section>
    );

    const borderRadius = 0;

    return (
        <div className={s.Details}>
            <header className={s.header}>
                <Heading level="1">{product.title}</Heading>
                {subtitle}
                <p>{product.short_description}</p>
            </header>
            {options.application.length > 1 && (
                <Tabs
                    tabs={tabs}
                    activeTab={activeTabId}
                    onTabClick={id => changeTab(id)}
                />
            )}
            <div className={s.meta}>
                {options.glass.length > 0 && (
                    <Section>
                        <GlassOptions
                            options={options.glass}
                            containerState={containerState}
                            setContainerState={setContainerState}
                            selectedGlassType={containerState.selectedGlassType}
                            selectedGlassDesign={
                                containerState.selectedGlassDesign
                            }
                            borderRadius={borderRadius}
                            swatchSize={containerState.swatchSize}
                        />
                    </Section>
                )}
                {options.texture.length > 0 && (
                    <Section>
                        <Heading level="2">{textureHeading}</Heading>
                        <Swatches
                            values={options.texture.map(texture => ({
                                label: texture.name,
                                value: texture.hash,
                                color: "#ccc",
                                image: texture.image_url
                            }))}
                            borderRadius={borderRadius}
                            selectedSwatch={null}
                            swatchSize={containerState.swatchSize}
                            selectHandler={() => {}}
                            scrollLeft={containerState.selectSpecieScrollPos}
                            handleUnmount={scrollLeft => {
                                if (
                                    containerState.selectSpecieScrollPos !==
                                    scrollLeft
                                )
                                    setContainerState("selectSpecieScrollPos")(
                                        scrollLeft
                                    );
                            }}
                            showLabels
                            showTooltip
                            handleTooltipClick={hash =>
                                containerState.showTooltipFor === hash
                                    ? setContainerState("showTooltipFor")(null)
                                    : setContainerState("showTooltipFor")(hash)
                            }
                            showTooltipFor={containerState.showTooltipFor}
                        />
                    </Section>
                )}
                {options.finish.length > 0 && (
                    <Section>
                        <Heading level="2">
                            {language === "fr" ? "Finition" : "Finish"}
                        </Heading>
                        <Swatches
                            values={options.finish.map(finish => ({
                                label: finish.name,
                                value: finish.hash,
                                color: "#ccc",
                                image: finish.image_url
                            }))}
                            borderRadius={borderRadius}
                            selectedSwatch={null}
                            swatchSize={containerState.swatchSize}
                            selectHandler={() => {}}
                            scrollLeft={
                                containerState.selectFinishScrollPos
                            }
                            handleUnmount={scrollLeft => {
                                if (
                                    containerState.selectFinishScrollPos !==
                                    scrollLeft
                                )
                                    setContainerState(
                                        "selectFinishScrollPos"
                                    )(scrollLeft);
                            }}
                            showLabels
                            showTooltip
                            handleTooltipClick={hash =>
                                containerState.showTooltipFor === hash
                                    ? setContainerState("showTooltipFor")(
                                            null
                                        )
                                    : setContainerState("showTooltipFor")(
                                            hash
                                        )
                            }
                            showTooltipFor={containerState.showTooltipFor}
                        />
                    </Section>
                )}
            </div>
        </div>
    );
};

export default Details;
